import { baseTheme } from '@src/theme';
import { Drawer } from 'antd';
import { ComponentType } from 'react';
import { styled } from 'styled-components';

export const StyledDrawer = styled(Drawer as ComponentType<any>)`
    .ant-drawer-wrapper-body {
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
    }

    .ant-drawer-header {
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        border-bottom: 1px solid
            ${(props) =>
                props.theme?.colors?.secondary?.light?.divider ||
                baseTheme.colors.secondary.light.divider};
        padding: 16px 24px;
        margin-bottom: 16px;
    }

    .ant-drawer-title {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }

    .ant-drawer-body {
        padding: 24px;
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }

    .ant-drawer-close {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.icon ||
            baseTheme.colors.secondary.main.icon};

        &:hover {
            color: ${(props) =>
                props.theme?.colors?.secondary?.dark?.icon ||
                baseTheme.colors.secondary.dark.icon};
        }
    }

    .ant-drawer-footer {
        border-top: 1px solid
            ${(props) =>
                props.theme?.colors?.secondary?.light?.divider ||
                baseTheme.colors.secondary.light.divider};
        padding: 16px 24px;
    }

    .ant-drawer-content {
        border-radius: 8px;
    }

    .ant-drawer-mask {
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.dark?.surfaceBg ||
            baseTheme.colors.secondary.dark.surfaceBg};
    }
`;

export const StyledDrawerHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledDrawerTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    h3 {
        font-size: 18px;
        font-weight: 500;
        margin: 0;
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }
`;

export const StyledDrawerFooter = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
`;
